import resize from "../resize";
import IMask from "imask";
import vanillaToast from "vanilla-toast";
import axios from "axios";
import metrics from "../metrics";
import { Category, EmploymentFormat, Education } from "./constants";

const form = () => {
  const citizenRequest =
      "https://hermes.smile-tech.study/api/v1/lead?programId=",
    FlowCRM = "https://2025.api.tgu-dpo.ru/citizenrequest/InternalNewRequest";
  /* Замена текста в зависимости от ширины экрана */
  function resizeForm() {
    const text = document.querySelector(".form__info-change");

    if (!text) {
      return;
    }

    if (innerWidth > 996) {
      text.innerHTML = "справа";
    } else {
      text.innerHTML = "снизу";
    }
  }

  const invalidCharsRegex = /[^a-zA-Z0-9.@_-]/; // Разрешённые символы

  $("[type=email]").on("input", function () {
    const inputValue = $(this).val();

    // Проверяем наличие недопустимых символов
    const invalidChars = inputValue.match(invalidCharsRegex);
    const input = $(this).get(0);
    const inputParent = $(this).parent().get(0);

    if (input.classList.contains("form__field--invalid")) {
      input.classList.remove("form__field--invalid");
      inputParent.querySelector(".form__error-container")?.remove();
    }
    const error = {};

    if (invalidChars) {
      error.message = `Недопустимый символ: "${invalidChars[0]}"`;
      input.classList.add("form__field--invalid");

      showError(error, inputParent);
    }
  });

  // Подсказки для ввода почты
  const validDomains = [
    "yandex.ru",
    "mail.ru",
    "gmail.com",
    "hotmail.com",
    "outlook.com",
  ];

  $("[type=email]").on("input", function () {
    const emailInput = $(this);
    const emailValue = emailInput.val();
    const suggestionsDiv = emailInput.siblings(".suggestions");

    const atIndex = emailValue.indexOf("@");
    if (atIndex !== -1) {
      const domainPart = emailValue.slice(atIndex + 1);
      const suggestions = validDomains.filter((domain) =>
        domain.startsWith(domainPart)
      );
      suggestionsDiv.empty(); // Очистка предыдущих подсказок

      if (suggestions.length > 0) {
        suggestions.forEach((domain) => {
          suggestionsDiv.append(
            `<span class="suggestion-item">${emailValue.slice(
              0,
              atIndex + 1
            )}${domain}</span>`
          );
        });
        suggestionsDiv.show();
      } else {
        suggestionsDiv.hide();
      }
    } else {
      suggestionsDiv.hide();
    }
  });

  // Обработчик клика на предложениях
  $(document).on("click", ".suggestion-item", function () {
    const emailInput = $(this).closest("form").find("[type=email]");
    emailInput.val($(this).text()).focus();
    emailInput.siblings(".suggestions").hide();
  });

  /* Валидаторы */
  const validators = {
    requried: function (value, error) {
      if (!value || value.length === 0) {
        error.message = "Это поле обязательно";
        return false;
      } else {
        return true;
      }
    },
    phone: function (value, error) {
      if (
        /^((\+7|7|8)\s?\(?(\d{3})\)?[\s-]?(\d{3})[\s-]?(\d{2})[\s-]?(\d{2}))$/.test(
          value
        )
      ) {
        return true;
      } else {
        error.message = "Некорректный номер телефона";
        return false;
      }
    },
    email: function (value, error) {
      if (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
        return true;
      } else {
        error.message = "Некорректный email";
        return false;
      }
    },
    birthday: function (value, error) {
      var parts = value.split(".");
      if (
        parts.length != 3 ||
        parts[0].length != 2 ||
        parts[1].length != 2 ||
        parts[2].length != 4
      ) {
        error.message = "Некорректная дата рождения";
        return false;
      }

      return true;
    },
  };

  /* Добавление ошибок валидации */
  function showError(error, field) {
    if (error.message) {
      var errorContainer = document.createElement("div");
      errorContainer.textContent = error.message;
      errorContainer.classList.add("form__error-container");
      field.appendChild(errorContainer);
    }
  }

  /* Удаление ошибок валидации */
  function deleteErrors(form) {
    form.querySelectorAll(".form__error-container").forEach(function (el) {
      el.remove();
    });
    form.querySelectorAll(".form__field--invalid").forEach(function (el) {
      el.classList.remove("form__field--invalid");
    });
  }

  /* Валидация формы */
  function validate(form) {
    let result = true;

    Array.from(form.querySelectorAll(".form__field")).forEach(function (
      formField
    ) {
      let error = {},
        control = formField.querySelector("select, input, textarea");

      if (formField.querySelector(".form__required")) {
        if (!validators.requried(control.value, error)) {
          showError(error, formField);
          control.classList.add("form__field--invalid");
          result = false;
          return;
        }
      }

      if (control.type === "tel") {
        if (!validators.phone(control.value, error)) {
          showError(error, formField);
          control.classList.add("form__field--invalid");
          result = false;
        }
      }

      if (control.type === "email") {
        if (!validators.email(control.value, error)) {
          showError(error, formField);
          control.classList.add("form__field--invalid");
          result = false;
        }
      }

      if (control.id === "birthday") {
        if (!validators.birthday(control.value, error)) {
          showError(error, formField);
          control.classList.add("form__field--invalid");
          result = false;
        }
      }
    });

    let invalidField = form.querySelector(".form__field--invalid");
    if (invalidField) {
      invalidField.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }

    return result;
  }

  /* Получения cookie */
  function getCookie(cname) {
    let name = cname + "=",
      decodedCookie = decodeURIComponent(document.cookie),
      ca = decodedCookie.split(";");

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];

      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }

      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }

    return "";
  }

  /* Проверка ИНН */
  function validateInn(INN) {
    var result = false;
    let inn = +INN;

    if (typeof inn === "number") {
      inn = inn.toString();
    } else if (typeof inn !== "string") {
      inn = "";
    }

    if (!inn.length) {
      result = false;
    } else if (/[^0-9]/.test(inn)) {
      result = false;
    } else if ([10].indexOf(inn.length) === -1) {
      result = false;
    } else {
      result = true;
    }

    return result;
  }

  function send(form, e) {
    var sendBtn = form.querySelector(
      'button[type="submit"], input[type="submit"]'
    );
    e.preventDefault();
    deleteErrors(form);
    var data = {};
    if (!validate(form)) {
      return;
    }
    sendBtn.disabled = true;
    Array.from(new FormData(form)).forEach(function (formElement) {
      var key = formElement[0];
      var value = formElement[1];
      if (key == "BirthDate") {
        data[key] = value.split(".").reverse().join("-");
      } else if (key == "Region") {
        data[key] = returnRegionName("#Regions option", value);
        data["RegionId"] = value;
      } else if (key == "ParticipationSZ") {
        if (value == "true") {
          data["ParticipationSZ"] = true;
        } else {
          data["ParticipationSZ"] = false;
        }
      } else if (key == "City") {
        data["city_id"] = Number(value);
      } else if (key == "category") {
        data[key] = Category[value] ? Category[value] : value;
      } else if (key == "EmploymentFormat") {
        data[key] = EmploymentFormat[value] ? EmploymentFormat[value] : value;
      } else if (key == "Education") {
        data[key] = Education[value] ? Education[value] : value;
      } else {
        data[key] = value;
      }
    });

    // Добавление поля Категории для сайтов unemployed и dismissalrisk
    if (document.location.pathname == "/unemployed") {
      data["category"] = "1";
    }

    if (document.location.pathname == "/dismissalrisk") {
      data["category"] = "11";
    }

    let url = document.location.href,
      paramsStartIndex = url.indexOf("?");

    // UTM
    if (paramsStartIndex > -1) {
      url
        .slice(paramsStartIndex + 1, url.length)
        .split("&")
        .map(function (utmString) {
          return utmString.split("=");
        })
        .forEach(function (utmMark) {
          var key = utmMark[0];
          key = key[0].toUpperCase() + key.slice(1, key.length);
          var value = utmMark[1];
          value =
            value.indexOf("#") > -1
              ? value.slice(0, value.indexOf("#"))
              : value;
          data[key] = value;
        });
    } else {
      if (getCookie("utm_tags")) {
        getCookie("utm_tags")
          .slice(paramsStartIndex + 1, getCookie("utm_tags").length)
          .split("&")
          .map(function (utmString) {
            return utmString.split("=");
          })
          .forEach(function (utmMark) {
            var key = utmMark[0];
            key = key[0].toUpperCase() + key.slice(1, key.length);
            var value = utmMark[1];
            value =
              value.indexOf("#") > -1
                ? value.slice(0, value.indexOf("#"))
                : value;
            data[key] = value;
          });
      }
    }

    if (!data.Program) {
      const title = document.querySelector(".home__title").textContent;
      let newProgram = title.slice(title.indexOf("«") + 1, title.indexOf("»"));
      data["Program"] = newProgram;
    }

    data["Landing"] = url.split("?")[0] || url;

    toastr.options.progressBar = true;

    /* Добавление данных в передачу формы */
    const programList = document.querySelector("#Program")?.children,
      programHidden = form.querySelector(".program-hidden");

    if (programList && !programHidden) {
      [...programList].forEach((item) => {
        if (data["Program"] == item.value) {
          if (item.getAttribute("operator")) {
            data["Operator"] = item.getAttribute("operator");
          }

          if (item.getAttribute("program_id")) {
            if (
              item.getAttribute("program_id") == "null" ||
              item.getAttribute("program_id") == null
            ) {
              data["program_id"] = null;
            } else {
              data["program_id"] = Number(item.getAttribute("program_id"));
            }
          }

          if (item.getAttribute("linkrvr")) {
            data["rvr_link"] = item.getAttribute("linkrvr");
          }
        }
      });
    } else {
      if (programHidden.getAttribute("operator")) {
        data["Operator"] = programHidden.getAttribute("operator");
      }

      if (programHidden.getAttribute("program_id")) {
        if (
          programHidden.getAttribute("program_id") == "null" ||
          programHidden.getAttribute("program_id") == null
        ) {
          data["program_id"] = null;
        } else {
          data["program_id"] = Number(programHidden.getAttribute("program_id"));
        }
      }

      if (programHidden.getAttribute("linkrvr")) {
        data["rvr_link"] = programHidden.getAttribute("linkrvr");
      }
    }

    let ym_uid = getCookie("_ym_uid");
    if (ym_uid) {
      data["client_id"] = ym_uid;
    }

    /* AdvCake cookie берем до удаления cookie */
    let advcakeCookie = getCookie('advcake_track_id');

    /* Ройстат */
    let roistatCookie = getCookie("roistat_visit");
    if (!!roistatCookie) {
      data["RoistatCookie"] = roistatCookie;
    }

    axios
      .post(citizenRequest + data["program_id"], data)
      .then(function (result) {
        sendBtn.disabled = false;
        addAdvCakeScript(
          result.data.requestId,
          result.data.programName,
          data.Email,
          advcakeCookie
        );

        formSubmitFlow(data);
        onSuccess(data);

        /* Метрики */
        if (window.yaCounter74433037) {
          yaCounter74433037.reachGoal("FormSubmit");
          ym(74433037,'reachGoal','FormSubmitAdaptive');
        }
        if (setFBQ) {
          setFBQ(data);
        }
        fbq("track", "Lead");
        VK.Goal("lead");
        VK.Retargeting.Event("lead");
        var _tmr = window._tmr || (window._tmr = []);
        _tmr.push({ id: "3244339", type: "reachGoal", goal: "lead" });

        if (data["EmploymentFormat"] === "2") {
          ym(74433037, "reachGoal", "submit_form_trud");
        }

        form.reset();
        $("#Category").val("").trigger("change");
        $("#Education").val("").trigger("change");
        $("#EmploymentFormat").val("").trigger("change");
        $("#Regions").val("").trigger("change");
        $("#City").val("").trigger("change");
        $("#Program").val("").trigger("change");
      })
      .catch(function (error) {
        console.log(error);
        sendBtn.disabled = false;
        toastr.error(
          "Пожалуйста, проверьте ваше соединение с сетью или повторите попытку позже",
          { duration: 3000, fadeDuration: 500 }
        );
      });
  }

  /* Отправка формы в АМО */
  function formSubmitFlow(data) {
    data["FirstName"] = data["name"];
    data["Phone"] = data["phone"];
    data["Email"] = data["email"];
    data["LastName"] = "-";
    data["category"] = getKeyByValue(Category, data["category"]);
    data["EmploymentFormat"] = getKeyByValue(
      EmploymentFormat,
      data["EmploymentFormat"]
    );
    data["Education"] = getKeyByValue(Education, data["Education"]);

    axios.post(FlowCRM, data);
  }

  /* Полчуние ключа объекта */
  function getKeyByValue(object, value) {
    return Object.keys(object).find((key) => object[key] === value);
  }

  /**
   * Функция для определения вывода модальных окон после успешной отправки формы
   */
  function onSuccess(data = null) {
    let urlRvR = null;

    if (data !== null) {
      if (data.rvr_link && data.rvr_link !== "undefined") {
        urlRvR = data.rvr_link;
      }
    }

    if (urlRvR) {
      /* FLOW-12326 */
      // openSuccessModal(urlRvR, data["Operator"]);
      setTimeout(() => {
        const newTab = window.open(urlRvR, "_blank");
        if (newTab) {
          newTab.focus();
        } else {
          window.location.assign(urlRvR);
        }
        ym(74433037, "reachGoal", "click_RR");
        ym(74433037, "reachGoal", "wait_redirect");
      }, 0);
    } else {
      openNoRedirectSaveBaseModal();
    }

    toastr.success("Анкета успешно отправлена", "Успех!");

    const container = document.querySelector(".form__container");
    if (container) {
      container.classList.add("success-container");
      container.innerHTML = `<div class="card" style="
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                padding: 3rem;
                max-width: 100%;
            ">
                <h2 class="title" style="text-align: center; margin: 0;">
                Ваша заявка успешно отправлена
                </h2>
            </div>`;
      if (!data || !data.url) {
        document.querySelector(".banner__btn").click();
      }
    }
  }

  /**
   * Функция добавления стилей
   */
  function setStyles(el, stylesObject) {
    if (!el) {
      return;
    }
    Object.keys(stylesObject).forEach((key) => {
      el.style[key] = stylesObject[key];
    });
  }

  /**
   * Событие для fbq
   */
  function setFBQ(data = null) {
    if (data && data.leadId) {
      fbq("track", "Lead", {}, { eventID: data.leadId });
    }
  }

  /**
   * Функция с модальными окнами при успешной отправки фломы
   */
  function successModal() {
    let modal = document.querySelector("#quiz-success"),
      botLink;

    if (!modal) {
      modal = document.createElement("div");
      ["modal", "quiz"].forEach((additionalClass) => {
        modal.classList.add(additionalClass);
      });
      modal.id = "quiz-success";
      modal.innerHTML = '<div class="quiz__content"></div>';

      document.body.append(modal);
    }

    const a = document.createElement("a");
    a.href = "#quiz-success";
    a.rel = "modal:open";
    a.style.display = "none";
    document.body.append(a);

    window.openSuccessModal = (url = "", operator) => {
      /* Инструкция */
      // const downloadInstruction = document.createElement("a");
      // downloadInstruction.setAttribute("download", "");
      // downloadInstruction.style.display = "none";
      // document.body.append(downloadInstruction);
      // downloadInstruction.href = INSTRUCTION;
      // downloadInstruction.click();

      /* Скачивание лид магнита */
      // const downloadLead = document.createElement("a");
      // downloadLead.href = "/files/Kak_uvelichit_dohod_v_2024_godu.pdf";
      // downloadLead.setAttribute("download", "");
      // downloadLead.style.display = "none";
      // document.body.append(downloadLead);
      // downloadLead.click();

      if (operator == "TGU") {
        botLink = "https://salebot.site/ff4cf9b214c75cd7e132af3c2a07fa7a_1";
      } else {
        botLink = "https://t.me/SigmaszBot";
      }

      const withLink = url.length > 0;
      if (withLink) {
        modal.classList.add("rvr-modal");
        setStyles(modal, {
          position: "relative",
          paddingBottom: "2rem",
          pointerEvents: "auto",
        });
        modal.querySelector(".quiz__content").innerHTML = `
          <h3 class="title--decor rvr-modal__title">Поздравляем с&nbsp;успешной регистрацией!</h3>
          <p class="norvr-modal__p">Далее вам необходимо подтвердить заявку на&nbsp;портале &laquo;Работа в&nbsp;России&raquo; в&nbsp;течение 3&nbsp;дней.</p>
          <p class="rvr-modal__redirect">
              Через <span class="timer"> 15 </span> секунд вы будете автоматически перенаправлены на <a href="${url}" onclick="ym(74433037,'reachGoal','click_RR')">портал «Работа России»</a>
          </p>
          <p class="norvr-modal__p"><strong>Это обязательное условие для участия в&nbsp;проекте &laquo;Активные меры содействия занятости&raquo;.</strong></p>
          
          <div class="important">
            <div class="important__content">
              <p>На&nbsp;указанную почту мы&nbsp;пришлем <span>подробные инструкции</span> как:</p>
              <p><span>&#149;&nbsp;пройти все шаги</span> до&nbsp;зачисления на&nbsp;программу;</p>
              <p><span>&#149;&nbsp;вступить в&nbsp;чат</span> программы;</p>
              <p><span>&#149;&nbsp;начать обучение</span> в&nbsp;ближайшей группе.</p>
              <p><b>Не&nbsp;забывайте проверять папку &laquo;Спам&raquo;.</b></p>
            </div>
          </div>
          <div class="rvr-modal__bottom">
            <p>Остались вопросы? Напишите в&nbsp;<a class="TelegramClickSZ TelegramBotClick" href="https://t.me/TGUinfoBot" rel="nofollow noopener noreferrer" target="_blank">Telegram-бот</a>, наши кураторы ответят на&nbsp;все вопросы и&nbsp;помогут найти решение, расскажут как работодателю подписать договор о&nbsp;намерениях.</p>
            <a href="https://t.me/TGUinfoBot" class="rvr-modal__link TelegramClickSZ TelegramBotClick" rel="nofollow noopener noreferrer" target="_blank" data-bot-link>Вступить&nbsp;в&nbsp;чат&nbsp;программы</a>
          </div>
        `;

        setTimerRedirect(modal.querySelector(".timer"));
      }
      a.click();
      document.querySelector(".rvr-modal .close-modal").style.display = "none";
      metrics();
    };

    window.openModalListPrograms = (region) => {
      let data = [];

      Top5Programs.forEach((item) => {
        if (item.regionId == region) {
          data = item.programsSuggestions;
        }
      });

      if (data.length < 1) {
        openNoRedirectSaveBaseModal();
        return;
      }

      modal.classList.add("norvr-modal", "rvr-modal");
      setStyles(modal, {
        position: "relative",
        padding: "40px",
      });

      modal.querySelector(".quiz__content").innerHTML = /*html*/ `
          <div class="norvr-modal__top">
            <h3 class="norvr-modal__h3">К сожалению, в&nbsp;вашем регионе программа не&nbsp;реализуется</h3>
          </div>
          <br>
          <p class="norvr-modal__p">Но вы все еще можете пройти <strong>бесплатное обучение</strong> и&nbsp;получить помощь в&nbsp;старте карьеры по другим программам. Вот какие программы доступны в&nbsp;вашем регионе:</p>
          <div class="norvr-modal__programs"></div>`;

      data.forEach((item) => {
        document.querySelector(".norvr-modal__programs").innerHTML += `
                  <a href="${item.rvrLink}" target="_blank">${item.programName}</a>
                `;
      });

      a.click();
    };

    window.openNoRedirectSaveBaseModal = () => {
      // const downloadLead = document.createElement("a");
      // downloadLead.href = "/files/Kak_uvelichit_dohod_v_2024_godu.pdf";
      // downloadLead.setAttribute("download", "");
      // downloadLead.style.display = "none";
      // document.body.append(downloadLead);
      // downloadLead.click();

      modal.classList.add("norvr-modal", "rvr-modal");
      setStyles(modal, {
        position: "relative",
        paddingBottom: "2rem",
      });

      modal.querySelector(".quiz__content").innerHTML = /*html*/ `
        <h3 class="title--decor rvr-modal__title">Благодарим за заявку!</h3>
        <p class="norvr-modal__p">Ваша заявка попала в&nbsp;список приоритетных кандидатов.</p>
        <div class="important">
          <div class="important__content">
            <p>На&nbsp;указанную почту мы&nbsp;пришлем <span>подробные инструкции</span> как:</p>
            <p><span>&#149;&nbsp;пройти все шаги</span> до&nbsp;зачисления на&nbsp;программу;</p>
            <p><span>&#149;&nbsp;вступить в&nbsp;чат</span> программы;</p>
            <p><span>&#149;&nbsp;начать обучение</span> в&nbsp;ближайшей группе.</p>
            <p><b>Не&nbsp;забывайте проверять папку &laquo;Спам&raquo;.</b></p>
          </div>
        </div>
        <div class="rvr-modal__bottom">
          <p>Остались вопросы? Напишите в&nbsp;<a class="TelegramClickSZ TelegramBotClick" href="https://t.me/TGUinfoBot" rel="nofollow noopener noreferrer" target="_blank">Telegram-бот</a>, наши кураторы ответят на&nbsp;все вопросы и&nbsp;помогут найти решение, расскажут как работодателю подписать договор о&nbsp;намерениях.</p>
          <a href="https://t.me/TGUinfoBot" class="rvr-modal__link TelegramClickSZ TelegramBotClick" rel="nofollow noopener noreferrer" target="_blank" data-bot-link>Вступить&nbsp;в&nbsp;чат&nbsp;программы</a>
        </div>
      `;

      a.click();
      metrics();
    };
  }

  /**
   * Таймер редиректа
   */
  function setTimerRedirect(el) {
    if (!el) {
      console.error("Не передан элемент");
      return;
    }
    const interval = setInterval(() => {
      if (el.textContent === "0" || Number(el.textContent) < 1) {
        clearInterval(interval);
        return;
      }
      el.textContent = Number(el.textContent) - 1;
    }, 1000);
  }

  /* Начало заполнения формы */
  function onFormFilling(form, callback) {
    const controls = form.querySelectorAll("input, select, textarea");
    let changed = false;
    controls.forEach((control) => {
      $(control).one("blur", (e) => {
        if (!changed) {
          callback(e);
          changed = true;
        }
      });
    });
  }

  /* Вызов функций */
  let phoneInput = document.getElementById("phone");
  let phoneModalInput = document.getElementById("phone-modal");

  if (phoneInput) {
    new IMask(phoneInput, {
      mask: "+{7} (000) 000-00-00",
    });
  }

  if (phoneModalInput) {
    new IMask(phoneModalInput, {
      mask: "+{7} (000) 000-00-00",
    });
  }

  /* Возвращает название региона для отправки формы */
  function returnRegionName(id, region) {
    let regionList = document.querySelectorAll(id);

    for (let i = 0; i < regionList.length; i++) {
      if (region == regionList[i].value) {
        return regionList[i].textContent;
      }
    }
  }

  /**
   * Установка формы
   */
  function setForm(selector, small = false) {
    var form = document.querySelector(selector);

    if (!form) {
      return;
    }

    form.addEventListener("submit", function (e) {
      send(form, e, small);
    });

    addMaxLength(form);
    onFormFilling(form, () => {
      ym(74433037, "reachGoal", " filling");
      ym(74433037,'reachGoal','FormStartAdaptive');
      VK.Retargeting.Event("Initiate_Checkout");
    });
  }

  /**
   * Установка максимального количества символов в полях формы
   */
  function addMaxLength(form) {
    form
      .querySelectorAll('input[type="text"], textarea')
      .forEach((control) => control.setAttribute("maxlength", "250"));
  }

  /**
   * Блокировка кнопки отправки формы
   */
  function setFormCheckbox(arr, btn) {
    try {
      arr.forEach((item) => {
        item.addEventListener("change", function () {
          if (!arr.find((checkbox) => !checkbox.checked)) {
            btn.removeAttribute("disabled");
          } else {
            btn.setAttribute("disabled", "disabled");
          }
        });
      });
    } catch (e) {}
  }

  /* Инициализация функций */
  setForm("#form-app");
  setForm("#modal-main");
  setFormCheckbox(
    [
      document.querySelector("#form-check"),
      document.querySelector("#form-check--pd"),
    ],
    document.querySelector("#form-btn")
  );
  setFormCheckbox(
    [
      document.querySelector("#form-check-modal"),
      document.querySelector("#form-check-modal--pd"),
    ],
    document.querySelector("#form-btn-modal")
  );
  resize(resizeForm);
  resizeForm();
  successModal();

  /* Пользователь находится на сайте больше 30 сек  */
  setTimeout(() => {
    VK.Retargeting.Event("PageView30sec");
    fbq("track", "PageView30s");
  }, 30000);

  /* Добавление скрипта AdvCake на сайт */
  function addAdvCakeScript(id, program, email, advcakeCookie) {
    const pageUrl = document.location.href;

    window.advcake_data = window.advcake_data || [];
    window.advcake_data.push({
      pageType: 6,
      user: {
        email: `md5(${email})`,
        type: "",
      },
      leadInfo: {
        id: `${id}`,
        name: `${program}`,
        totalPrice: 0,
        coupon: "",
        marketing_cat: 1,
        trackId: `${advcakeCookie}`,
        url: `${pageUrl}`,
      },
    });
  }
};

export default form;
